import type { UiRuntimeMemoryDiagnostic } from "#ui-runtime-memory-types";

export async function readUiRuntimeMemory(_collect: boolean): Promise<UiRuntimeMemoryDiagnostic> {
  throw new Error("UI runtime memory diagnostics require an iOS native build.");
}

export async function uiRuntimeQueueBarrier(): Promise<void> {
  throw new Error("UI runtime memory diagnostics require an iOS native build.");
}
